





































































import Vue, { PropOptions } from 'vue';
import API from '@/api/common';
import * as NOCArray from '@/personal/array';
import * as models from '@/class/models/views/contact';
import {IAPP} from '@/class/models/views/app';
import SideMenu from '@/components/util/SideMenu.vue';
import VariableInput, {IVariableInput, INPUT_TYPE} from '@/components/util/VariableInput.vue';
import * as validation from '@/personal/validation';

export default Vue.extend({
  name: 'Contact',
  props: {
    appData: Object as PropOptions<IAPP>,
  },
  components: {
    SideMenu, VariableInput,
  },
  data() {
    return {
      disabled: false,
      modal: false,
      formData: {
        category: 0,
        content: '',
      } as models.IContact,
      items: [
        // {key: 'mail', name: 'メール', placeholder: '', required: true, checks: [validation.CHECK_TYPE.EMAIL], error: '', max: 40},
        {key: 'category', name: 'カテゴリー', type: INPUT_TYPE.SELECT, placeholder: '', required: true, checks: [], error: '', options: NOCArray.CONTACT },
        {key: 'content', name: '内容', type: INPUT_TYPE.TEXTAREA, placeholder: '500文字以内', required: true, checks: [], error: '', max: 500},
      ] as IVariableInput[] ,
    };
  },
  async mounted() {
    // データ取得
    // todo:tempkara
    this.$emit('pushPath', this.$route.path);
    this.formData.regist = true;
  },
  methods: {
    async onClickContact(): Promise<boolean> {

      // メールを合成
      this.formData.mail = this.appData.mail;

      // validation エラーの場合
      if (validation.checkValues(this.formData, this.items) > 0) {
        return false;
      }
      this.disabled = true;
      // api start
      const api = new API();
      const res = await api.post<models.IContact, {deneid: boolean}>('contact', this.formData);
      this.disabled = false;
      // result
      if (res.result) {
        if (!res.data.deneid) {
          this.modal = true;
        } else {
          this.$emit('info', '1日のお問い合わせは4件までになります。');
        }
      } else {
        this.$emit('info', '通信できませんでした。');
        return false;
      }
      this.resetForm();
      return true;
    },
    onPushPath(path: string) {
      this.$router.push(path, () => {});
      this.$emit('pushPath', path);
    },
    resetForm() {
      this.formData.category = NOCArray.CONTACT[0].value;
      this.formData.content = '';
    },
  },
});

